import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router';

class JournalEntry extends React.Component {

   render() {
      return (
         <div className="JournalEntry" >
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/journalEntry/" activeStyle={{ color: 'red' }} >JournalEntry</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li><Link to="/journalEntry/newJournalEntry" >NewJournalEntry</Link></li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      );
   }
}

JournalEntry.propTypes = {
   children: PropTypes.object
};

export default JournalEntry;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/JournalEntries/JournalEntry.js
 **/